import { call, ForkEffect, put, takeEvery } from 'redux-saga/effects';

import { isResetEmailCaptureWithDelayStartAction } from '../actions/reset-email-capture-with-delay-start';
import { createResetEmailCaptureWithDelaySuccessAction } from '../actions/reset-email-capture-with-delay-success';

function delay (): Promise<void> {
    return new Promise((resolve: () => void): NodeJS.Timeout => {
        return setTimeout(resolve, 5000);
    });
}

export function* resetEmailCaptureWithDelayStartSaga (): Iterator<any> {
    yield call(delay);
    yield put(createResetEmailCaptureWithDelaySuccessAction());
}

export function* watchResetEmailCaptureWithDelayStart (): Iterator<ForkEffect> {
    yield takeEvery(isResetEmailCaptureWithDelayStartAction, resetEmailCaptureWithDelayStartSaga);
}
